import { Divider, Input } from 'antd';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { PageHeader } from '../theme/theme';

const SettingsItemStyle = styled(Link)`
	padding: 20px;
	border-bottom: 1px solid #ddd;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	transition: background-color 400ms ease;

	& .desc {
		width: 75%;
		font-size: 15px;
		color: #969696;
		margin-top: 10px;
	}

	& .icon {
		width: 50px;
		display: flex;
		flex-direction: column;
		height: 100%;
		justify-content: flex-start;
		margin-right: 10px;
	}

	&:hover {
		background-color: #fafafa;
	}
`;

const ThirdpartyPage = () => {
	const items = [
		{
			title: 'Bikanda',
			desc: 'Manage and track your Bikanda integrations and transactions.',
			link: '/thirdparty/bikanda',
			icon: 'rectangle',
		},
		{
			title: 'Liquidity Providers',
			desc: 'Different settings for the smooth running of the app.',
			link: '/thirdparty/liquidity-providers',
			icon: 'rectangle',
		},
		{
			title: 'MadWallet Stats',
			desc: 'Get reports from MadWallet web3 browser extension.',
			link: 'Monitor statistics form MadWallet by Xend Finance.',
			icon: 'rectangle',
		},
		{
			title: 'XendBridge Sell Requests Log',
			desc: 'Find a Sell Requests initiated data.',
			link: '/thirdparty/xendbridge-sell-request',
			icon: 'rectangle',
		},
	];

	return (
		<section>
			<PageHeader>ThirdParty Integrations</PageHeader>

			<Input.Search placeholder="Search Settings" />

			<Divider />

			<p>Frequently visited</p>

			<Divider />

			{items
				.sort((prev, next) => prev.title.localeCompare(next.title))
				.map((item) => (
					<SettingsItemStyle key={item.title} to={item.link}>
						<div style={{ display: 'flex' }}>
							<div className="icon">
								<span className="material-icons">{item.icon}</span>
							</div>
							<div>
								<p>
									<strong>{item.title}</strong>
								</p>
								<p className="desc">{item.desc}</p>
							</div>
						</div>
						<div className="arrow">
							<span className="material-icons">keyboard_arrow_right</span>
						</div>
					</SettingsItemStyle>
				))}
		</section>
	);
};

export default ThirdpartyPage;
